import { useEffect, useState } from "react";
import { Menu, X, Cpu } from "lucide-react";

const links = [
    { label: "Problema", href: "#problema" },
    { label: "Soluzione", href: "#soluzione" },
    { label: "Moduli", href: "#moduli" },
    { label: "Per chi è", href: "#per-chi" },
    { label: "Metodo", href: "#metodo" },
    { label: "FAQ", href: "#faq" },
    { label: "Contatti", href: "#contatti" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/80 backdrop-blur-xl border-b border-slate-200/70 shadow-[0_1px_0_rgba(0,0,0,0.02)]"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="brand-logo"
                    className="flex items-center gap-2.5 group"
                >
                    <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-[#0B1120] to-[#0f172a] shadow-sm">
                        <Cpu className="w-5 h-5 text-cyan-400" strokeWidth={2.25} />
                        <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-teal-400 ring-2 ring-white" />
                    </span>
                    <span className="flex flex-col leading-none">
                        <span className="font-display font-bold text-[19px] text-slate-900 tracking-tight">
                            TecSuite
                        </span>
                        <span className="text-[10.5px] uppercase tracking-[0.18em] text-slate-500 font-medium mt-0.5">
                            by Tecnologie
                        </span>
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.href.replace("#", "")}`}
                            className="nav-link text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <a
                        href="#contatti"
                        data-testid="header-cta-demo"
                        className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors shadow-sm"
                    >
                        Richiedi demo
                        <span className="inline-block h-1.5 w-1.5 rounded-full bg-cyan-400 pulse-dot" />
                    </a>
                    <button
                        onClick={() => setOpen((v) => !v)}
                        data-testid="mobile-menu-toggle"
                        aria-label="Apri menu"
                        className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-xl"
                >
                    <div className="px-6 py-4 flex flex-col gap-1">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
                                className="py-3 text-base font-medium text-slate-800 border-b border-slate-100 last:border-0"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#contatti"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-cta-demo"
                            className="mt-3 inline-flex items-center justify-center rounded-full bg-slate-900 text-white text-sm font-semibold px-5 py-3"
                        >
                            Richiedi demo
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
